import {
  UseAdvancedStatisticsDataListQuery,
  UseAdvancedStatisticsDataListQueryVariables,
} from "@/gql/graphql";
import { useLazyQuery } from "@apollo/client";
import { UseAdvancedStatisticsDataList } from "./UseStatisticsByAdvancedListQuery";

export const useAdvancedStatisticsDataListQuery = () => {
  const [loadAdvancedStatisticsData, { loading, data, error }] = useLazyQuery<
    UseAdvancedStatisticsDataListQuery,
    UseAdvancedStatisticsDataListQueryVariables
  >(UseAdvancedStatisticsDataList, {
    fetchPolicy: "network-only",
  });

  return {
    error,
    loading,
    advancedStatisticsData: data?.statistics.advancedList.byFilter?.items,
    loadAdvancedStatisticsData,
  };
};
